<template>
  <div v-click-outside="clickOutSide" class="col-sm-3">
    <!-- Single button -->
    <div :class="{ open: dropOpen }" class="btn-group btn-block">
      <button
        type="button"
        class="btn btn-default btn-lg dropdown-toggle"
        style="width: 100%"
        @click="toggle"
      >
        <p class="large hidden-sm tw-whitespace-normal">
          {{ $t('Select category') }}
          <span class="caret" />
        </p>
        <p class="small hidden-xs hidden-md hidden-lg">
          {{ $t('Category') }}
          <span class="caret" />
        </p>
      </button>
      <ul class="dropdown-menu select-category">
        <li v-if="binder" @click="selectCategory(null)">
          <a href="#">
            {{ $t('All categories') }}
            <span class="badge">
              {{ totalJobs }}
            </span>
          </a>
        </li>
        <!-- eslint-disable-next-line vue/no-v-for-template-key -- Baseline eslint ignore please fix if working on this-->
        <template v-for="category in categories.list" :key="category.id">
          <li
            v-if="category.parent_id == 0"
            :class="{ active: binder && binder[category.id] }"
            @click="selectCategory(category)"
          >
            <a href="#">
              {{ $t(category.name) }}
              <span class="badge">
                {{ category.nestedCount }}
              </span>
            </a>
          </li>
        </template>
      </ul>
    </div>
    <div v-if="current" class="text-center clear bgm-lightgray p-10">
      {{ current.name }}
    </div>
    <div class="visible-xs m-b-10" />
  </div>
</template>

<script>
function countJobsNested(category, cats) {
  // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
  if (category.parent_id != 0) {
    return category.yjobs_available_count
  }
  let count = category.yjobs_available_count
  cats.forEach((cat) => {
    // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
    if (cat.parent_id == category.id) {
      count += countJobsNested(cat)
    }
  })
  return count
}

function countParentsJobs(cats) {
  if (cats !== null) {
    cats.forEach((category) => {
      // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
      if (category.parent_id == 0) {
        // We have a parent category
        // eslint-disable-next-line no-param-reassign -- Baseline eslint ignore please fix if working on this
        category.nestedCount = countJobsNested(category, cats)
      }
    })
  }
}

function countTotalJobs(cats) {
  let total = 0
  cats.forEach((category) => {
    total += category.yjobs_available_count
  })
  return total
}

export default {
  name: 'SelectCategories',
  props: {
    refCategories: {
      type: Object,
      required: true,
    },
    refStore: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dropOpen: false,
      current: null,
    }
  },
  computed: {
    categories() {
      return this.refCategories
    },
    binder: {
      get() {
        return this.categories.selected
      },
      set(val) {
        if (this.refStore) {
          this.refStore.store.commit(this.refStore.mutator, val)
        } else {
          this.categories.selected = val
        }
      },
    },
    totalJobs() {
      return this.jobs.length
    },
    jobs() {
      const list = this.$store.getters.jobList
      return list[0] && list[0]['no-jobs-msg'] === undefined ? list : []
    },
  },
  watch: {
    'categories.list': {
      deep: true,
      handler() {
        this.findSelected()
        this.updateJobsCount()
      },
    },
    'categories.selected': {
      handler() {
        this.findSelected()
      },
      deep: true,
    },
    jobs: {
      deep: true,
      handler() {
        this.updateJobsCount()
      },
    },
  },
  created() {
    this.updateJobsCount()
    this.findSelected()
  },
  methods: {
    eaquels(list) {
      // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
      if (!this.binder || this.binder.length != list.length) return false

      for (let i = 0; i < list.length; i++) {
        // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
        if (this.binder[i] != list[i]) {
          return false
        }
      }
      return true
    },
    toggle(define) {
      if (define !== undefined) {
        this.dropOpen = define
      } else {
        this.dropOpen = !this.dropOpen
      }
    },
    clickOutSide(e) {
      this.toggle(false)
    },
    selectCategory(category) {
      const assigner = []

      if (category) {
        assigner[category.id] = category.id
        this.categories.list.forEach((cat) => {
          // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
          if (cat.parent_id == category.id) {
            assigner[cat.id] = cat.id
          }
        })
      }

      if (!this.eaquels(assigner)) {
        this.binder = assigner
      }

      if (this.binder.length < 1) {
        this.current = null
      } else {
        this.current = category
      }
      this.toggle(false)
    },
    updateJobsCount() {
      if (this.categories.list === null) return

      const list = []
      for (const job of this.jobs) {
        if (list[job.category_id] === undefined) {
          list[job.category_id] = 1
        } else {
          list[job.category_id] += 1
        }
      }
      for (const cat of this.categories.list) {
        cat.yjobs_available_count = 0
      }

      for (const catId in list) {
        if (this.categories.list[catId] !== undefined) {
          this.categories.list[catId].yjobs_available_count = list[catId]
        }
      }

      countParentsJobs(this.categories.list)
    },
    // Sees if an id belongs to a parent category
    isParent(id) {
      let isAParent = false
      this.categories.list.forEach((cat) => {
        // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
        if (cat.id == id && cat.parent_id === 0) {
          isAParent = true
        }
      })
      return isAParent
    },
    getCategoryById(id) {
      let theCat
      this.categories.list.forEach((cat) => {
        // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
        if (cat.id == id) {
          theCat = cat
        }
      })
      return theCat
    },
    findSelected() {
      if (this.binder && this.binder.length > 0) {
        this.binder.forEach((category) => {
          if (category && this.categories.list && this.isParent(category)) {
            this.selectCategory(this.getCategoryById(category))
          }
        })
      } else if (this.binder && this.binder.length < 1) {
        this.selectCategory(null)
      }
    },
  },
}
</script>

<style scoped lang="scss">
button {
  min-height: 54px;
  p {
    padding: 0;
    margin: 0;
  }
  @media screen and (max-width: 1479px) {
    font-size: 18px;
    padding: 10px 15px;
  }
}
</style>
